<template>
  <div
    class="flex items-center border-[1px] border-[#E5E5E5] rounded-[10px] h-[36px] overflow-hidden transition-colors"
    :class="{
      'border-primary ring-[2px] ring-[#E5E5E5] ring-offset-[1px]': isFocused,
      'cursor-not-allowed bg-[#F5F5F5]': disabled,
      'bg-white': !disabled,
    }"
  >
    <input
      type="number"
      class="flex-1 h-full text-center outline-none border-none text-[14px] hide-arrows disabled:bg-transparent disabled:cursor-not-allowed disabled:text-[#737373] text-[#0A0A0A] w-0"
      :value="value"
      :min="min"
      :max="max"
      :disabled="disabled"
      aria-label="Quantity"
      @input="handleInput"
      @focus="isFocused = true"
      @blur="isFocused = false"
    >
    <div class="flex flex-col h-full w-[24px]">
      <button
        class="flex-1 flex items-center justify-center hover:bg-[#F5F5F5] focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        :disabled="disabled || (max !== null && value >= max)"
        aria-label="Increase quantity"
        @click="increment"
      >
        <feather-icon
          icon="ChevronUpIcon"
          size="12"
        />
      </button>
      <button
        class="flex-1 flex items-center justify-center hover:bg-[#F5F5F5] focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        :disabled="disabled || value <= min"
        aria-label="Decrease quantity"
        @click="decrement"
      >
        <feather-icon
          icon="ChevronDownIcon"
          size="12"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpinnerInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocused: false,
    }
  },
  methods: {
    increment() {
      if (this.disabled) return
      const nextVal = this.value + 1
      if (this.max !== null && nextVal > this.max) return
      this.$emit('input', nextVal)
    },
    decrement() {
      if (this.disabled) return
      if (this.value > this.min) {
        this.$emit('input', this.value - 1)
      }
    },
    handleInput(e) {
      let val = parseInt(e.target.value, 10)
      if (Number.isNaN(val) || val < this.min) {
        val = this.min
      } else if (this.max !== null && val > this.max) {
        val = this.max
      }
      this.$emit('input', val)
      this.$forceUpdate()
    },
  },
}
</script>

<style scoped>
/* hide arrows for number input */
.hide-arrows::-webkit-outer-spin-button,
.hide-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.hide-arrows {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
